import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { BasketSideNavComponent } from './basket-sidenav/basket-sidenav.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UnitModule } from '@lib/unit';
import { DisplayCurrencyModule } from '@lib/util';

@NgModule({
    imports: [CommonModule, TranslateModule, MatTooltipModule, UnitModule, DisplayCurrencyModule],
    declarations: [BasketSideNavComponent],
    exports: [BasketSideNavComponent],
})
export class SharedBasketSidenavUiModule {}
